// 260615nrai: datetimepicker's bundled mousewheel UMD only assigns module.exports under
// CommonJS and never calls the factory, so wheel events lack deltaY and year/month lists
// jump to the top (1950). Invoke the exported factory on our shared jQuery instance.
import $ from '../jquery_setup/jquery_and_migrate';
import mousewheelFactory from 'jquery-datetimepicker';

if (typeof mousewheelFactory === 'function' && !$.event.special.mousewheel) {
  mousewheelFactory($);
}
